import { OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

export abstract class ResponsiveConditionDirective implements OnInit, OnDestroy {
  private mediaQueryList: MediaQueryList;
  private mediaQueryListener: (event: MediaQueryListEvent) => void;
  private hasView = false;

  protected constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private mediaQuery: string
  ) {}

  ngOnInit() {
    if (typeof window === 'undefined' || !window.matchMedia) {
      this.updateView(false);
      return;
    }

    this.mediaQueryList = window.matchMedia(this.mediaQuery);
    this.mediaQueryListener = (event: MediaQueryListEvent) => this.updateView(event.matches);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.mediaQueryListener);
    } else {
      this.mediaQueryList.addListener(this.mediaQueryListener);
    }

    this.updateView(this.mediaQueryList.matches);
  }

  ngOnDestroy() {
    if (!this.mediaQueryList || !this.mediaQueryListener) {
      return;
    }

    if (this.mediaQueryList.removeEventListener) {
      this.mediaQueryList.removeEventListener('change', this.mediaQueryListener);
    } else {
      this.mediaQueryList.removeListener(this.mediaQueryListener);
    }
  }

  private updateView(shouldShow: boolean) {
    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
